import { NestedPayment } from '../api/payments/types';

type PaymentGrouped = {
  amount: number;
  bankAccountDestinationId: number;
  bankAccountOriginId: number;
  cut: string;
};

type AccountLike = { id: number; accountNumber: string; bankName?: string };

export function mapPreviousPaymentsToGrouped(
  payments: NestedPayment[],
  availableAccounts: AccountLike[],
  originAccounts: AccountLike[],
): PaymentGrouped[] {
  if (!payments?.length) return [];

  const groupKey = (p: NestedPayment) =>
    `${p.bankAccountDestinationId ?? ''}-${p.bankAccountOriginId ?? ''}`;

  const grouped = new Map<
    string,
    {
      amount: number;
      amounts: number[];
      destNumber: number;
      originNumber: number;
    }
  >();

  for (const p of payments) {
    const key = groupKey(p);
    const dest = p.bankAccountDestinationId;
    const origin = p.bankAccountOriginId;
    if (!grouped.has(key)) {
      grouped.set(key, {
        amount: 0,
        amounts: [],
        destNumber: dest,
        originNumber: origin,
      });
    }
    const g = grouped.get(key)!;
    g.amount += p.amount;
    g.amounts.push(p.amount);
  }

  return Array.from(grouped.values()).map((g) => {
    const destAccount = availableAccounts.find((a) => a.id === g.destNumber);
    const originAccount = originAccounts.find((a) => a.id === g.originNumber);
    const amount = g.amount;
    const cut = (() => {
      if (g.amounts.length <= 1) return 'sin-corte';
      const CUT_7M = 7000000;
      const CUT_5M = 5000000;
      const countByAmount = new Map<number, number>();
      for (const a of g.amounts) {
        countByAmount.set(a, (countByAmount.get(a) ?? 0) + 1);
      }
      let maxCount = 0;
      let mostRepeated: number | null = null;
      for (const [amt, count] of countByAmount) {
        if (count > maxCount && (amt === CUT_7M || amt === CUT_5M)) {
          maxCount = count;
          mostRepeated = amt;
        }
      }
      if (mostRepeated != null) return String(mostRepeated);
      return 'sin-corte';
    })();

    return {
      bankAccountDestinationId: destAccount?.id ?? 0,
      bankAccountOriginId: originAccount?.id ?? 0,
      amount,
      cut,
    };
  });
}
